import { type ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { cn } from '@/lib/utils';
import type { PatientTaskPriority } from '@/features/patient-record/types';

const PRIORITY_CLASSES: Record<PatientTaskPriority, string> = {
  URGENT: 'border-destructive/40 text-destructive bg-destructive/10',
  HIGH: 'border-warning/40 text-warning bg-warning/10',
  MEDIUM: 'border-border text-muted-foreground bg-muted',
  LOW: 'border-border text-muted-foreground bg-transparent',
};

/** Shared priority chip used by the tasks panel, chip preview, and My Cases inbox. */
export function TaskPriorityBadge({
  priority,
}: {
  readonly priority: PatientTaskPriority;
}): ReactElement {
  const { t } = useTranslation();
  return (
    <span
      className={cn(
        'text-[9.5px] font-semibold uppercase tracking-wider rounded-sm border px-1 py-0.5 leading-none',
        PRIORITY_CLASSES[priority],
      )}
    >
      {t(`patient.tasks.priority.${priority}`)}
    </span>
  );
}
